const loadJQuery = async () => {
    if (typeof $ !== "undefined" && $.fn.jquery >= "1.7" && $.fn.jquery < "3.2") {
        ApexChat.ApexChatJquery = $;
        console.log(`jquery already exists on client browswer with version: ${$.fn.jquery}`);
    } else {
        if (ApexChat.ApexChatJquery) return;
        const module = await import(/* webpackChunkName: "jquery" */ 'jquery')
        console.log("jquery loaded!")
        ApexChat.ApexChatJquery = module.default
        ApexChat.ApexChatJquery = module.default.noConflict(true);

    }
}
export default loadJQuery;